import { cn } from '@/lib/utils';

export default function P({ children, className }: { children: string; className?: string }) {
    return <p className={cn('text-p font-normal', className)}>{children}</p>;
}
